module.exports = {"singular":"Veranstaltungsort","plural":"Veranstaltungsorte","date_range":"Datum","name":"Ort"};